import(/* webpackMode: "eager", webpackExports: ["useUser"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@auth0/nextjs-auth0/dist/client/hooks/use-user.js");
;
import(/* webpackMode: "eager", webpackExports: ["Auth0Provider"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@auth0/nextjs-auth0/dist/client/providers/auth0-provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Calculator"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/calculator/components/Calculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/will/Documents/Business/wise/repos/wise/site/themes/catalyst/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/home/will/Documents/Business/wise/repos/wise/site/themes/catalyst/link.tsx");
